/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const DioceseSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['*']
    filtro.addOrder('descricao', 'asc')
  return filtro
}
